import {FC} from 'react';

type UIChipProps = {
  text: string;
  type: ('gray' | 'white');
  onClick: Function;
  isSelected: boolean;
  key: number;
  element: any;
}

const UIChip: FC<UIChipProps> = ({text, type, onClick, isSelected, element}) => {
  return (
    <div
      key={element.key}
      onClick={() => onClick()}
      className=
        {`${isSelected ? 'bg-navy-primary text-white' : (type === 'gray' ? 'bg-gray-200' : 'bg-white')} ` +
        'flex-1 text-center py-3 rounded-md text-xs shadow-chip'}>
      {text}
    </div>
  );
};

export default UIChip;
